import React, { useState, useEffect } from 'react';
import Sidemenu from '../base/sidemenu';
import { useLocation, useNavigate } from 'react-router-dom';
import { editFamilyInfo, getRelation } from '../../services/userApiServicer';
import {formatMobilePhone} from "../../utils/phoneFormatter"

export default function UserFamilyEdit() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = location.state?.userData;
  const [relList, setRelvList] = useState([]);
  const token = localStorage.getItem("token");
  console.log("location.state.userData 값:", user.family);
  const today = new Date().toISOString().split('T')[0];
  const [families, setFamilies] = useState([
    { name: '', phone: '', relation_id: '', birth: '', user_id: user.id }
  ]);
  const [originalFamilyCount, setOriginalFamilyCount] = useState(0);





  useEffect(() => {
    const getRevList = async () => {
      try {
        const data = await getRelation(token);
        if (data.success === false) {
          alert(data.message);
          return;
        }
        setRelvList(data.relation);
      } catch (error) {
        console.error("서비스 목록 불러오기 실패:", error);
      }
    };
    getRevList();
    if (user?.family?.length > 0) {
      setFamilies(user.family);
      setOriginalFamilyCount(user.family.length);
      console.log("가족 수정  : ", user.family);
    } else {
      setOriginalFamilyCount(1);
    }
  }, [user]);

  const handleGoBack = () => {
    navigate(-1);
  };
  const handleSave = async () => {
    try {
      console.log("family :: ", families);
      const response = await editFamilyInfo(token, families);
      console.log(response);
      if (response.data.success) {
        console.log('가족 정보 저장 성공:', response.data);
        alert('가족 정보가 수정되었습니다.');
        navigate(`/user/${user.id}`);
      } else {
        console.warn('가족 정보 저장 실패:', response.data.message || '알 수 없는 오류');
        alert(`${response.data.message || '알 수 없는 오류'}`);
        //navigate(`/user/${user.id}`);
      }
    } catch (error) {
      console.error('가족 정보 저장 중 에러 발생:', error.response?.data || error.message);
      alert('가족 정보 수정에 실패했습니다.');
    }
  };

  const updateFamily = (index, field, value) => {
    const newFamilies = [...families];
    newFamilies[index][field] = value;
    setFamilies(newFamilies);
  };

  // 가족 추가 함수
  const addFamily = () => {
    const newFamily = { name: '', phone: '', relation_id: '', birth: '', user_id: user.id };
    setFamilies([...families, newFamily]);
  };

  // 가족 삭제 함수 - 새로 추가한 가족만 삭제 가능
  const removeFamily = (index) => {
    if (index >= originalFamilyCount) {
      const newFamilies = families.filter((_, i) => i !== index);
      setFamilies(newFamilies);
    } else {
      alert('기존 가족 정보는 삭제할 수 없습니다. 수정만 가능합니다.');
    }
  };

  return (
    <div className='flex'>
      <Sidemenu />
      <div className="user">
        <h1>사용자 가족 수정</h1>
        <div className="user_box">
          <h2 className="subpage_title"><span className="before"><span className="nametit">가족 정보 수정</span></span></h2>

          <div className='user_writebox'>
            {families.map((family, index) => (
              <div key={index}>
                <div className='table02'>
                  <table>
                    <caption>가족 정보 수정 표</caption>
                    <colgroup>
                      <col width="20%" />
                      <col width="80%" />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th scope="row">사용자 가족의 이름</th>
                        <td>
                          <input
                            type="text"
                            placeholder="사용자 가족의 이름을 입력하세요."
                            value={family.name || ''}
                            onChange={(e) => updateFamily(index, 'name', e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">연락처</th>
                        <td>
                          <input
                            type="text"
                            placeholder="사용자 가족의 연락처를 입력하세요."
                            value={family.phone || ''}
                            onChange={(e) => updateFamily(index, 'phone', formatMobilePhone(e.target.value))}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">관계</th>

                        <td>
                          <select
                            value={family.relation_id || ''}
                            onChange={(e) => updateFamily(index, 'relation_id', e.target.value)}>
                            <option value="" disabled>관계를 선택하세요.</option>
                            {Array.isArray(relList) && relList.map(rel => (
                              <option key={rel.id} value={rel.id}>{rel.name}</option>
                            ))}
                          </select>
                        </td>

                      </tr>
                      <tr>
                        <th scope="row">생년월일</th>
                        <td>
                          <input
                            type="date"
                            className='date'
                            max={today}
                            placeholder="사용자 가족의 생년월일을 입력해주세요."
                            value={family.birth}
                            onChange={(e) => updateFamily(index, 'birth', e.target.value)}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* 삭제 버튼 - 새로 추가한 가족만 삭제 가능 */}
                {index >= originalFamilyCount && (
                  <div className="btn-group" style={{ textAlign: 'right', marginTop: '10px', marginBottom: '10px' }}>
                    <button
                      type="button"
                      className="btncolor03"
                      onClick={() => removeFamily(index)}
                    >
                      삭제
                    </button>
                  </div>
                )}
              </div>
            ))}


          </div>


          <div className="btn-group">
            <button className="btncolor02" onClick={handleGoBack}>뒤로</button>
            <button className="btncolor04" onClick={addFamily}>가족추가</button>
            <button className="btncolor01" onClick={handleSave}>수정완료</button>
          </div>
        </div>
      </div>
    </div>
  );
}